// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Treemap_wrap__3U7_a","noData":"Treemap_noData__3RTFC"};